module.exports = __webpack_public_path__ + "static/assets/315909607ab00b746ce6a5c926056c14.png";